import React from "react";

import { Box } from "@chakra-ui/react";

import { BusinessAdminsTable } from "./BusinessAdminsTable";

export const BusinessAdmins = () => {
  return (
    <Box className="mt-1">
      <BusinessAdminsTable />
    </Box>
  );
};
